import * as React from 'react';

function SvgStats(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 20 16" {...props}>
			<path
				fill="currentColor"
				fillRule="evenodd"
				d="M3.846 6.4c.425 0 .77.358.77.8v8c0 .442-.345.8-.77.8H.77c-.426 0-.77-.358-.77-.8v-8c0-.442.344-.8.77-.8h3.076zM14.103 0c.424 0 .769.358.769.8v14.4c0 .442-.345.8-.77.8h-3.076c-.425 0-.77-.358-.77-.8V.8c0-.442.345-.8.77-.8h3.077zm5.128 1.6c.425 0 .769.358.769.8v12.8c0 .442-.344.8-.77.8h-3.076c-.425 0-.77-.358-.77-.8V2.4c0-.442.345-.8.77-.8h3.077zM8.974 4.8c.425 0 .77.358.77.8v9.6c0 .442-.345.8-.77.8H5.897c-.424 0-.769-.358-.769-.8V5.6c0-.442.345-.8.77-.8h3.076zm-5.59 2.88H1.232v7.04h2.154V7.68zm10.257-6.4h-2.154v13.44h2.154V1.28zm5.128 1.6h-2.154v11.84h2.154V2.88zM8.513 6.08H6.359v8.64h2.154V6.08z"
			/>
		</svg>
	);
}

export default SvgStats;
